angular.module("Main").controller("PayPalShopSuccessController", ["$rootScope", "$scope", "$state", "$window", "$localStorage", "$stateParams", "$location", "$translate", "$uibModal", "PaymentService", "BookingService", "SessionService", "ShopService",
    function ($rootScope, $scope, $state, $window, $localStorage, $stateParams, $location, $translate, $uibModal, PaymentService, BookingService, SessionService, ShopService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'shopData');
            //unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.hasError = true;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isPayPal = true;
        vm.isPayed = true;

        if (!SessionService.getSessionId()) {
            $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            let userData = $localStorage.user;
            ShopService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (status.status === 'TIMEOUT') {
                    vm.bookingLost = true;
                    vm.cashBack = false;
                } else {
                    if (status.Status !== 'CAPTURED') {
                        ShopService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                            vm.isPayment = true;
                            vm.zahlmethode = 'PayPal';
                            vm.Bild = data.qrCode;
                            if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                                vm.rechnungsNr = data.data.rechnungsNr;
                            }
                        }).catch(function (error) {
                            ShopService.cancelBooking($stateParams.oid, $translate.use(), 'ERROR');
                            $state.go("shop_fail_pp", {
                                cid: $stateParams.cid,
                                message: error,
                                id: $stateParams.id,
                                oid: $stateParams.oid
                            });
                            vm.hasError = true;
                            throw error;
                        }).then(function () {
                            ShopService.capturePaymentPayPal($stateParams.oid).then(function () {
                                vm.captured = true;
                                vm.hasError = false;
                                ShopService.getOnlineShopConfiguration().then(function (data) {
                                    vm.onlineShopConfig = data;
                                });
                                vm.shopData = {
                                    OrderNr: $stateParams.oid,
                                    Name: vm.status.Bezeichnung,
                                    Preis: vm.status.Preis,
                                    PersonNr: vm.status.PersonNr,
                                    BookingNr: vm.status.BookingNr,
                                    Status: vm.status.Status,
                                    Confirmed: vm.status.Confirmed
                                };
                                vm.shopData.RechnungsNr = vm.rechnungsNr;
                                vm.shopData.BookingNr = vm.status.BookingNr;
                                getDataByRIDForConfirm();
                            }).catch(function (error) {
                                ShopService.cancelBooking($stateParams.oid, $translate.use(), 'ERROR');
                                $state.go("shop_fail_pp", {
                                    cid: $stateParams.cid,
                                    rid: $stateParams.rid,
                                    id: $stateParams.id,
                                    oid: $stateParams.oid
                                });
                                vm.hasError = true;
                            })
                        })
                    } else {
                        vm.hasError = false;
                        vm.isPayment = true;
                        vm.zahlmethode = 'PayPal';
                        vm.shopData = {
                            OrderNr: $stateParams.oid,
                            Name: vm.status.Bezeichnung,
                            Preis: vm.status.Preis,
                            PersonNr: vm.status.PersonNr,
                            BookingNr: vm.status.BookingNr,
                            Status: vm.status.Status,
                            Confirmed: vm.status.Confirmed
                        };
                        vm.shopData.RechnungsNr = vm.status.RechnungsNr;
                        vm.shopData.BookingNr = vm.status.BookingNr;
                        getDataByRIDForConfirm();
                    }
                }
            }).catch(function (error) {
                $state.go("shop_fail_pp", {cid: $stateParams.cid, rid: $stateParams.rid, id: $stateParams.id, oid: $stateParams.oid});
                vm.hasError = true;
                throw error
            });
        }

        function getDataByRIDForConfirm() {
            vm.member = {};
            SessionService.setAuthData($stateParams.cid);
            if($localStorage.user && $localStorage.user.uid) {
                vm.personNr = vm.shopData.PersonNr;
                let userData = $localStorage.user;
                BookingService.getUserDetails(userData.uid).then(function (data) {
                    vm.memberNr = vm.personNr;
                    vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
                    vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
                    vm.member = $localStorage.user;
                    vm.member.firstname = $localStorage.user.Firstname;
                    vm.member.lastname = $localStorage.user.Lastname;
                    vm.member.email = $localStorage.user.Email;
                    if (!_.isNil(data)) {
                        vm.isLoggedIn = true;
                        vm.username = data.firstname + " " + data.lastname;
                        vm.hideLogin = true;
                        $rootScope.$emit("login");
                    }
                })
            } else {
                ShopService.getUserDataByRIDForConfirm($stateParams.rid).then(function (data) {
                    vm.member.email = data.email;
                    vm.member.firstname = data.firstname;
                    vm.member.lastname = data.lastname;
                })
            }

        }

    }])